<div class="topbar">
  <div class="left">
    <a class="brand" routerLink="/monitoramento" aria-label="Página inicial">
      <span class="logo" aria-hidden="true">
        <img src="/logo_tracing_xs.svg" alt="Logo" width="78" height="24" />
      </span>
    </a>

    <span class="divider"></span>

    <nav class="support-switcher" *ngIf="showSupportSwitcher">
      <a
        class="support-link"
        routerLink="/suporte"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        >Gerenciar Clientes</a
      >
      <a class="support-link" routerLink="/suporte/usuarios" routerLinkActive="active"
        >Gerenciar Usuários</a
      >
      <a class="support-link" routerLink="/suporte/equipamentos" routerLinkActive="active">Gerenciar Equipamentos</a>
    </nav>

    <div class="project-wrapper" *ngIf="showProjectSelector">
      <button
        class="project"
        [class.disabled]="!canChangeProject"
        type="button"
        (click)="toggleProjectMenu()"
        [attr.aria-expanded]="projectMenuOpen"
        aria-haspopup="listbox"
      >
        <span class="project-name" [class.muted]="loadingProject">
          {{ loadingProject ? 'Carregando projeto...' : 'Projeto: ' }}
        </span>
        <span class="project-loading" *ngIf="loadingProject" aria-hidden="true"></span>
        <span class="project-id" *ngIf="projectId">
          {{ projectLabel }}
        </span>
        <span class="caret" *ngIf="canChangeProject" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 10l5 5 5-5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </button>

      <div class="project-menu-backdrop" *ngIf="projectMenuOpen" (click)="closeProjectMenu()"></div>
      <div class="project-menu" *ngIf="projectMenuOpen">
        <div class="project-menu-title">Projetos</div>
        <ng-container *ngIf="showClientSelector; else projectOnlyMenu">
          <div class="project-menu-list">
            <div class="client-group" *ngFor="let client of clients">
              <div class="client-title">{{ client.name }}</div>
              <button
                *ngFor="let project of client.projects"
                class="project-option"
                type="button"
                [class.selected]="project.id === projectId"
                (click)="selectProject(project.id, client.id)"
              >
                <div>
                  <div class="project-option-name">{{ project.name }}</div>
                </div>
                <span aria-hidden="true" *ngIf="project.id === projectId">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5 13l4 4L19 7"
                      stroke="#2563eb"
                      stroke-width="2.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #projectOnlyMenu>
          <div class="project-menu-row">
            <button
              *ngFor="let project of projects"
              class="project-option"
              type="button"
              [class.selected]="project.id === projectId"
              (click)="selectProject(project.id)"
            >
              <div>
                <div class="project-option-name">{{ project.name }}</div>
              </div>
              <span aria-hidden="true" *ngIf="project.id === projectId">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="#2563eb"
                    stroke-width="2.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="right" *ngIf="alertsList$ | async as alertsList">
    <div class="user-pill" *ngIf="userName">{{ userName }}</div>
    <div class="project-menu-backdrop" *ngIf="alertsOpen" (click)="closeAlerts()"></div>

    <div class="alerts-wrapper">
      <button
        class="icon-pill"
        type="button"
        (click)="toggleAlerts()"
        aria-haspopup="true"
        [attr.aria-expanded]="alertsOpen"
      >
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 6a5 5 0 0 0-5 5v3.5l-1.5 1.5v1h15v-1L19 14.5V11a5 5 0 0 0-5-5"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 19a2 2 0 0 0 4 0"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="badge" *ngIf="alertsList.length">{{ alertsList.length }}</span>
      </button>

      <div class="project-menu alerts-menu" *ngIf="alertsOpen">
        <div class="project-menu-title">Alertas</div>
        <div class="alerts-body">
          <div class="alerts-list" *ngIf="alertsList.length; else emptyAlerts">
            <div
              class="alert-item"
              *ngFor="let alert of alertsList"
              [class.danger]="alertView(alert).severity === 'danger'"
              (click)="openAlert(alert)"
            >
              <div class="alert-main">
                <div class="alert-title">{{ alertView(alert).title }}</div>
                <div class="alert-meta">
                  <span class="meta">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                      <path
                        d="M12 22c-3.5-2-7-5-7-9a7 7 0 0 1 14 0c0 4-3.5 7-7 9z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {{ alertView(alert).personName }}
                  </span>
                  <span class="meta">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 22s7-4.4 7-11a7 7 0 0 0-14 0c0 6.6 7 11 7 11z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <circle cx="12" cy="11" r="2.5" stroke="currentColor" stroke-width="2" />
                    </svg>
                    {{ alertView(alert).zoneName }}
                  </span>
                </div>
              </div>
              <div class="alert-right">
                <span class="alert-time" [class.danger]="alertView(alert).severity === 'danger'">{{
                  alertView(alert).timeLabel
                }}</span>
                <button
                  class="alert-delete"
                  type="button"
                  (click)="resolveAlert(alert, $event)"
                  aria-label="Resolver alerta"
                >
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6 6l12 12M18 6L6 18"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <ng-template #emptyAlerts>
            <div class="empty-alerts">Nenhum alerta no momento.</div>
          </ng-template>
        </div>
        <div class="alerts-footer">
          <div class="alerts-count">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17 5.6A7.2 7.2 0 0 0 12 4 7.5 7.5 0 0 0 4.5 11.5 7.5 7.5 0 0 0 12 19a7.2 7.2 0 0 0 5-1.6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path d="M12 8v4l3 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            {{ alertsList.length }} alertas
          </div>
        </div>
      </div>
    </div>

    <button class="icon-pill danger" type="button" (click)="logout()">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 17l5-5-5-5M20 12H9M11 19H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Sair</span>
    </button>
  </div>
</div>
